
import { useEffect } from "react";
import { FileText, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import BottomNavigation from "@/components/BottomNavigation";

// URL del sistema externo de facturas
const EXTERNAL_INVOICES_URL = "https://portalfacturas.app/";

const Invoices = () => {
  // Preparar información para enviar al sistema externo
  useEffect(() => {
    // Aquí podrías inicializar cualquier dato necesario
    // antes de la redirección
  }, []);

  // Manejador para redireccionar al sistema externo
  const handleRedirect = () => {
    window.open(EXTERNAL_INVOICES_URL, "_blank");
  };

  return (
    <div className="min-h-screen bg-gray-100 pb-16">
      {/* Header */}
      <header className="bg-primary text-white p-4">
        <div className="container mx-auto flex items-center">
          <FileText className="h-5 w-5 mr-2" />
          <h1 className="text-xl font-bold">Facturas</h1>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto p-4">
        <div className="bg-white p-6 rounded-lg shadow text-center">
          <div className="mb-6">
            <div className="mx-auto w-16 h-16 bg-primary-soft rounded-full flex items-center justify-center mb-4">
              <FileText className="h-8 w-8 text-primary" />
            </div>
            <h2 className="text-xl font-bold mb-2">Portal de Facturas</h2>
            <p className="text-gray-600 mb-6">
              Acceda al portal de facturas para ver y gestionar sus documentos de facturación.
            </p>
          </div>

          <Button
            onClick={handleRedirect}
            className="w-full py-6"
            variant="outline"
          >
            Ir al Portal de Facturas
            <ExternalLink className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </main>

      <BottomNavigation />
    </div>
  );
};

export default Invoices;
